module.exports = __webpack_public_path__ + "static/media/fish-cooked.147fb60b.svg";